import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import UsersTable from './UsersTable';
import RolesTable from './RolesTable';

import SpinnerBlock from '../../common/SpinnerBlock';

import { fetchGetUsersSearch, fetchGetUserRoles } from '../../../actions/settings';

import { USERS_SETTINGS_COUNT_ON_PAGE } from '../../../config';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const UsersBlock = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);

  const { t } = useAutoTranslation();

  const actualizeData = async (data = {}) => {
    setLoading(true);

    const result = await Promise.all([
      dispatch(fetchGetUsersSearch({ ...data, size: USERS_SETTINGS_COUNT_ON_PAGE })),
      dispatch(fetchGetUserRoles()),
    ]).finally(() => {
      setLoading(false);
    });

    const newUsers = result[0];
    setUsers(newUsers.users);

    const newRoles = result[1];
    setRoles(newRoles);
  };

  useEffect(() => {
    (async function () {
      await actualizeData();
    })();
  }, []);

  return (
    <>
      <div className="border-bottom">
        <h4 className="header-title">{t('Пользователи')}</h4>
      </div>

      <div style={{ position: 'relative', minHeight: '150px' }}>
        {loading ? (
          <SpinnerBlock show />
        ) : (
          <>
            <UsersTable
              users={users}
              roles={roles}
              actualizeData={actualizeData}
              setUsers={setUsers}
            />
            <div className="border-bottom" />
            <RolesTable roles={roles} users={users} actualizeData={actualizeData} />
          </>
        )}
      </div>
    </>
  );
};

export default UsersBlock;
